import type { ReactNode } from 'react';
import React from 'react';
import type { ContainerProps } from '@mui/material/Container';
import Container from '@mui/material/Container';

export type SiteContainerProps = Omit<ContainerProps, 'maxWidth'> & {
    children?: ReactNode;
};

export function SiteContainer({ children, ...props }: SiteContainerProps) {
    return (
        <Container maxWidth="lg" {...props}>
            {children}
        </Container>
    );
}
